<template>
  <vx-card title="Claims Sub Category">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getClaimsSubCategory"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Category</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].claimsCategoryId">
                      {{ data[indextr].claimsCategoryId }}
                    </vs-td>
                    <vs-td :data="data[indextr].claimsSubCategoryCode">
                      {{ data[indextr].claimsSubCategoryCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].claimsSubCategoryName">
                      {{ data[indextr].claimsSubCategoryName }}
                    </vs-td>
                    <vs-td :data="data[indextr].claimsCategoryId">
                      {{
                        claimsCategory(data[indextr].claimsCategoryId)
                          .claimsCategoryName
                      }}
                    </vs-td>

                    <vs-td>
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].claimsSubCategoryId)"
                        />
                        <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="
                            confirmDeleteRecord(
                              data[indextr].claimsSubCategoryId
                            )
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="gradient"
            color="primary"
            @click="promptAddNewRecord()"
            icon-pack="feather"
            icon="icon-plus"
            >Add</vs-button
          >
        </div>
      </div>
      <!-- ADD CLAIMS SUB-CATEGORY -->
      <vs-prompt
        class="email-compose"
        title="Add Claims Sub-Category"
        accept-text="Submit"
        @accept="onAddNewRecord"
        :is-valid="validForm"
        :active.sync="activePromptAddRecord"
      >
        <vx-card title="Please fill-out the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="claimsSubCategory.claimsSubCategoryCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="claimsSubCategory.claimsSubCategoryName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Category</span
              ><span style="color: red">*</span>
              <v-select
                name="Claims category"
                v-validate="'required'"
                class="w-full"
                v-model="claimsCategoryName"
                label="claimsCategoryName"
                :options="getClaimsCategory"
                placeholder="Please Select"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('claims category')"
                >{{ errors.first("claims category") }}</span
              >
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END CLAIMS SUB-CATEGORY -->

      <!-- EDIT SUB-CATEGORY -->
      <vs-prompt
        class="email-compose"
        title="Edit Claims Sub-Category"
        accept-text="Submit"
        @accept="onUpdateRecord"
        :is-valid="validForm"
        :active.sync="activePromptEditRecord"
      >
        <vx-card title="You may update the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="claimsSubCategory.claimsSubCategoryCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="claimsSubCategory.claimsSubCategoryName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Category</span
              ><span style="color: red">*</span>
              <v-select
                name="Claims category"
                v-validate="'required'"
                class="w-full"
                v-model="claimsCategoryName"
                label="claimsCategoryName"
                :options="getClaimsCategory"
                placeholder="Please Select"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('loan category')"
                >{{ errors.first("loan category") }}</span
              >
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END EDIT SUB-CATEGORY  -->
    </div>
  </vx-card>
</template>
<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      claimsSubCategory: {
        claimsSubCategoryCode: "",
        claimsSubCategoryName: "",
        claimsCategoryId: 1,
      },
      activePromptAddRecord: false,
      activePromptEditRecord: false,
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllClaimsSubCategory").catch((err) => {
      console.log(err);
    });
    this.$store.dispatch("lookup/getAllClaimsCategory").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    getClaimsSubCategory() {
      return this.$store.state.lookup.claimsSubCategory;
    },
    getClaimsCategory() {
      return this.$store.state.lookup.claimsCategory;
    },
    claimsCategoryName: {
      get() {
        return this.$store.getters["lookup/claimsCategoryName"](
          this.claimsSubCategory.claimsCategoryId
        );
      },
      set(obj) {
        this.claimsSubCategory.claimsCategoryId = obj.claimsCategoryId;
      },
    },
    claimsCategory() {
      return (id) => this.$store.getters["lookup/claimsCategoryName"](id);
    },
    validForm() {},
  },
  methods: {
    promptAddNewRecord() {
      this.activePromptAddRecord = true;
    },
    onAddNewRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/addClaimsSubCategory", this.claimsSubCategory)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Save Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
    editRecord(id) {
      const e = this.$store.getters["lookup/claimsSubCategoryName"](id);

      (this.claimsSubCategory.claimsSubCategoryId = id),
        (this.claimsSubCategory.claimsSubCategoryCode =
          e.claimsSubCategoryCode),
        (this.claimsSubCategory.claimsSubCategoryName =
          e.claimsSubCategoryName),
        (this.activePromptEditRecord = true),
        (this.claimsSubCategory.claimsCategoryId = e.claimsCategoryId);
    },
    onUpdateRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/updateClaimsSubCategory", this.claimsSubCategory)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Updated Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
  },
};
</script>
